module.exports = __webpack_public_path__ + "img/Best of Deutschschweiz Rot.9b4b1a6b.jpg";